const dashboardSelectedUavosReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_DASHBOARD_SELECTED_UAVOS':
      return [...action.payload];
    default:
      return state;
  }
};

export default dashboardSelectedUavosReducer;
